import useUnifiedUtilizationQueryParams from '../../../shared/components/UtilizationCharts/useUnifiedUtilizationQueryParams';

// Reports wrapper delegates to unified hook (ensures consistent behavior)
export default function useUtilizationQueryParams(
  params: Parameters<typeof useUnifiedUtilizationQueryParams>[0]
) {
  return useUnifiedUtilizationQueryParams({ ...params, useTrailingLag: true });
}
